import { render, staticRenderFns } from "./studioMetricRenderer.vue?vue&type=template&id=ac01315e&lang=pug&"
import script from "./studioMetricRenderer.vue?vue&type=script&lang=ts&"
export * from "./studioMetricRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports